<template>
  <div class="number-entry-modal-body">
    <div class="number-entry-modal-button-container number-entry-intable">
      <!-- <div>{{ rawValue }}</div> -->
      <div class="number-entry-row first">
        <div class="number-entry-cell" @mousedown="input('1')">
          <dx-button ref="1" class="digit">1</dx-button>
        </div>
        <div class="number-entry-cell" @mousedown="input('2')">
          <dx-button ref="2" class="digit">2</dx-button>
        </div>
        <div class="number-entry-cell last" @mousedown="input('3')">
          <dx-button ref="3" class="digit">3</dx-button>
        </div>
      </div>
      <div class="number-entry-row">
        <div class="number-entry-cell" @mousedown="input('4')">
          <dx-button ref="4" class="digit">4</dx-button>
        </div>
        <div class="number-entry-cell" @mousedown="input('5')">
          <dx-button ref="5" class="digit">5</dx-button>
        </div>
        <div class="number-entry-cell last" @mousedown="input('6')">
          <dx-button ref="6" class="digit">6</dx-button>
        </div>
      </div>
      <div class="number-entry-row">
        <div class="number-entry-cell" @mousedown="input('7')">
          <dx-button ref="7" class="digit">7</dx-button>
        </div>
        <div class="number-entry-cell" @mousedown="input('8')">
          <dx-button ref="8" class="digit">8</dx-button>
        </div>
        <div class="number-entry-cell last" @mousedown="input('9')">
          <dx-button ref="9" class="digit">9</dx-button>
        </div>
      </div>
      <div class="number-entry-row">
        <div class="number-entry-cell" @mousedown="input('plusminus')">
          <dx-button ref="plusminus" class="digit">+/-</dx-button>
        </div>
        <div class="number-entry-cell" @mousedown="input('0')">
          <dx-button ref="0" class="digit">0</dx-button>
        </div>
        <div class="number-entry-cell last" @mousedown="input('.')">
          <dx-button ref="." class="digit">.</dx-button>
        </div>
      </div>

      <div class="number-entry-row last">
        <div class="number-entry-cell last" @mousedown="input('clear')">
          <dx-button ref="clear" class="digit">Clear</dx-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    focusedCellData: {
      type: Object,
      default: () => {},
    },
    applyFocusClass: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      rawValue: [0],
      numberValue: 0,
    };
  },
  methods: {
    input(inputChar) {
      this.applyFocusClass();
      if (inputChar === "clear") {
        // this.$store.dispatch("numericInputStore/lastEntry", {
        //   value: 'clear',
        //   remove: true,
        // });
        this.rawValue = [0];
        this.numberValue = parseFloat(this.rawValue.join(""));
      } else if (inputChar === "plusminus") {
        this.numberValue = -this.numericValue;
      } else {
        this.rawValue.push(inputChar);
        this.numberValue = parseFloat(this.rawValue.join(""));
        if (this.numericValue < 0) {
          this.numberValue = -this.numberValue;
        }
      }
      this.$store.dispatch("numericInputStore/setFieldFocused", true);
      this.$store.dispatch("numericInputStore/updateValue", this.numberValue);
      this.$store.dispatch("numericInputStore/lastEntry", {
        value: inputChar,
        remove: false,
      });
      // this.$store.dispatch(
      //   "numericInputStore/updateSourceNumericValue",
      //   this.numberValue
      // );

      this.applyFocusClass();

      var btnInstance = this.$refs[inputChar].instance;
      btnInstance.repaint();
    },
  },
  computed: {
    ...mapGetters({
      numericValue: "numericInputStore/getNumericValue",
      sourceNumericValue: "numericInputStore/getSourceNumericValue",
      keyPadFocusChanged: "numericInputStore/getKeyPadFocusChanged",
      keyPadLastEntry: "numericInputStore/getLastEntry",
    }),
  },
  mounted() {
    this.numberValue = this.numericValue;
  },
  watch: {
    // sourceNumericValue: function(val, oldVal) {
    //   // eslint-disable-next-line no-console
    //   this.$logger.debug(`sourceNumericValue old:${oldVal} new: ${val}`);
    //   if (val === "NaN") val = 0;

    //   this.numberValue = val;
    //   this.rawValue = this.numberValue.toString().split("");
    // },
    // eslint-disable-next-line no-unused-vars
    keyPadFocusChanged: function (val, oldVal) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(`keyPadFocusChanged old:${oldVal} new: ${val}`);
      // if (val === "NaN") val = 0;

      this.numberValue = 0;
      this.rawValue = ["0"];
    },
    keyPadLastEntry: {
      handler(val) {
        if (val.remove) {
          this.numberValue = 0;
          this.rawValue = ["0"];
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.number-entry-modal-header {
  width: 100%;
}

.number-entry-modal-header {
  width: 100%;
}

.number-entry-modal-body {
  // min-width: 500px !important;
  max-width: 250px;
  margin: auto;

  i {
    color: #6e7587;
  }

  .dx-button {
    border: none;

    font-weight: 500;
    border-bottom-left-radius: 2.2px;
    border-bottom-right-radius: 2.2px;
    border-top-left-radius: 2.2px;
    border-top-right-radius: 2.2px;
    color: #6e7587;
    font-size: 26px;
    margin: 3px;
  }

  .dx-button.digit {
    background-color: white;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
  }

  .dx-button.command {
    background-color: #eeeff3;
    font-size: 22px;
  }

  .dx-button.enter {
    background-color: #20a4da;
    color: white;
    font-size: 22px;
  }

  .dx-button:disabled,
  .dx-button[disabled] {
    background-color: #e9ecef !important;
    color: black;
  }

  input:disabled,
  input[disabled] {
    background-color: #f9ffff !important;
    color: #6e7587;
  }
}

.number-entry-modal-input-container,
.number-entry-modal-button-container {
  padding: 0;
  margin: 0;
  background: #e0e0e2;
}

.number-entry-row {
  display: flex;
}

.number-entry-row.last {
  margin-bottom: 2px;
}

.number-entry-row.first {
  margin-top: 2px;
}

.number-entry-cell {
  margin: 5px;
  flex-grow: 1;
  flex-basis: 0;
  width: 100%;
}

.number-entry-cell.last {
  margin-right: 10px;
}

.number-entry-intable {
  display: table;
  width: 100%;
}

.number-entry-enter-container {
  position: absolute;
}

.number-entry-enter-container .dx-button {
  height: 96px;
}

.number-entry-backspace-wrapper {
  padding-top: 3px;
  font-size: 24px;
}

/* these icon color related scss extends are defined in Content\scss\base\_sprite.scss file 

 .number-entry-backspace-wrapper .icon {
  @extend %icon-gray40;
 }

 */

.dx-button.digit {
  // border-radius: 70%;
  // width: 75px !important;
  height: 60px !important;
  cursor: pointer;
  outline: none;
  border: none;
  // box-shadow: 0 9px #999;
}

// .dx-button.digit:active {
//   background-color: white;
//   box-shadow: 0 5px #666;
//   transform: translateY(4px);
// }

.number-entry-cell {
  text-align: center;
}

.number-entry-row.last {
  .dx-button.digit {
    // border-radius: unset;
    width: 100% !important;
    // margin: 10px 0 15px 0 !important;
    // height: 50px;
  }
}

// .number-entry-cell.last {
//   margin: 5px !important;
// }

//////////////////////////////////
.number-entry-modal-button-container {
  background: unset !important;
}
.number-entry-modal-body .dx-button.digit {
  color: black;
  height: 50px;
}

.dx-button.digit:hover {
  // background-color: white;
  // box-shadow: 0 5px rgba(0, 0, 0, 0.605);
  // transform: translateY(4px);
  // opacity: 0.5;
  background-color: #ebebeb;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
}

// .dx-button.digit:focus {
//   background-color: #ebebeb;
//   -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.32);
//   box-shadow: 0 1px 3px rgba(0,0,0,.32);
// }

// .dx-button.digit:active {
//   background-color: #b3b3b3;
//   -webkit-box-shadow: 0 4px 6px rgba(0,0,0,.32);
//   box-shadow: 0 4px 6px rgba(0,0,0,.32);
// }

// .dx-button.digit: {
//   background-color: #ebebeb;
//   -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.24);
//   box-shadow: 0 1px 3px rgba(0,0,0,.24);

// }
</style>
